import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from './local-storage.service';
import { SessionVariable } from '../enum/session-variable';
import { AuthService } from './auth.service';
import { SharedSignalsService } from './shared-signals.service';


@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  trasferSingal = inject(SharedSignalsService);

  constructor(private translateService: TranslateService, private storageService : LocalStorageService) {}

  // Initialize the translation service
  init() {
    this.translateService.addLangs(['en-US', 'ar-KW']); // Add supported languages

    const currentLanguage:any = this.storageService.getItem(SessionVariable.LANGUAGE);

    if(currentLanguage == null){
      this.storageService.setItem(SessionVariable.LANGUAGE, 'en-US');
    }

    this.trasferSingal.setTextDirection(currentLanguage == 'ar-KW' ? 'rtl' : 'ltr');
    this.translateService.setDefaultLang(currentLanguage ? currentLanguage : 'en-US'); // Set the default language
  }

  // Load translations for a specific language
  loadTranslations(lang: string) {
    this.storageService.setItem(SessionVariable.LANGUAGE, lang);
    return this.translateService.use(lang);
  }

  switchLanguage(lang: string) {
    this.storageService.setItem(SessionVariable.LANGUAGE, lang);
    this.translateService.setDefaultLang(lang); 
  }

  getLabelValue(key:string, param?:any){
    if(param){
      return this.translateService.instant(key, param);
    }else{
      return this.translateService.instant(key);
    }
   
  }
}
